import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

import ActionsField from './fields/ActionsField/ActionsField';
import BlockField from './fields/BlockInput/BlockField';
import CheckboxField from './fields/Checkbox/CheckboxField';
import CodeEditorField from './fields/CodeEditor/CodeEditorField';
import DropdownField from './fields/Dropdown/DropdownField';
import ErrorField from './fields/ErrorField/ErrorField';
import FieldPermissions from './fields/FieldPermissions/FieldPermisssions';
import FilesSelectorField from './fields/FilesSelectorField/FilesSelectorField';
import GeoField from './fields/GeoInput/GeoField';
import HeaderField from './fields/HeadersField/HeaderField/HeaderField';
import HeadersField from './fields/HeadersField/HeadersField';
import InputField from './fields/Input/InputField';
import ListField from './fields/ListField/ListField';
import ListFieldItem from './fields/ListField/ListFieldItem/ListFieldItem';
import MarkdownField from './fields/Markdown/MarkdownField';
import OptionField from './fields/OptionsField/OptionField/OptionField';
import OptionsField from './fields/OptionsField/OptionsField';
import PermissionContentType from './fields/PermissionContentType/PermissionContentType';
import PermissionField from './fields/PermissionField/PermissionField';
import PermissionsField from './fields/PermissionsField/PermissionsField';
import RadioField from './fields/RadioGroup/RadioField';
import RelationField from './fields/RelationField/RelationField';
import RichtextField from './fields/Richtext/RichtextField';
import SpaceSelectorField from './fields/SpaceSelectorField/SpaceSelectorField';
import SpaceSelectorItem from './fields/SpaceSelectorField/SpaceSelectorItem/SpaceSelectorItem';
import SwitchField from './fields/Switch/SwitchField';
import TextareaField from './fields/Textarea/TextareaField';
import VariantField from './fields/VariantsField/VariantField/VariantField';
import VariantsField from './fields/VariantsField/VariantsField';
import CtoCustomField from './form-components/CtoCustomField/CtoCustomField';
import CustomFormElement from './form-components/CustomFormElement/CustomFormElement';
import DirtyHandler from './form-components/DirtyHandler/DirtyHandler';
import FocusAfterSaveHandler from './form-components/FocusAfterSaveHandler/FocusAfterSaveHandler';
import FormStateHandler from './form-components/FormStateHandler/FormStateHandler';
import ValidationToastHandler from './form-components/ValidationToastHandler/ValidationToastHandler';

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldComponents: {
    PermissionsField,
    PermissionField,
    FieldPermissions,
    PermissionContentType,
    Input: InputField,
    Textarea: TextareaField,
    Checkbox: CheckboxField,
    Switch: SwitchField,
    ListField,
    ListFieldItem,
    GeoField,
    BlockInput: BlockField,
    Dropdown: DropdownField,
    OptionsField,
    OptionField,
    RelationField,
    RadioGroup: RadioField,
    Markdown: MarkdownField,
    RichText: RichtextField,
    VariantsField,
    VariantField,
    SpaceSelectorField,
    SpaceSelectorItem,
    CodeEditor: CodeEditorField,
    HeadersField,
    HeaderField,
    ActionsField,
    ErrorField,
    FilesSelectorField,
  },
  formComponents: {
    DirtyHandler,
    ValidationToastHandler,
    CustomFormElement,
    FormStateHandler,
    FocusAfterSaveHandler,
    CtoCustomField,
  },
  fieldContext,
  formContext,
});

export type UseAppForm = ReturnType<typeof useAppForm>;
